export default __webpack_public_path__ + "static/TrustAlice Illustrations--06-78e8c7f19c84ce012715a6efdc15835b.svg";